// extracted by mini-css-extract-plugin
module.exports = {"checkboxes":"FormCheckbox_checkboxes__yuOjw"};